import React from 'react';
import { CommonPageStep, ForgetPasswordPageStep } from '..';
import { isMobileOnly } from 'react-device-detect';
import { Navigate } from 'react-router-dom';
import { DesktopView } from './desktop/ForgetPassword.desktop';
import { MobileView } from './mobile/ForgetPassword.mobile';
import { useAppSelector } from '../../store/hooks';
import {
  selectAppPageStep,
  setAppPageStep,
} from '../../store/reducer/appStateSlice';
import { outsideComponentDispatch } from '../../store/store';
import { Login } from '../login';

export const ForgetPassword = (): JSX.Element => {
  // Redux Hooks
  const appPageStep = useAppSelector(selectAppPageStep);

  React.useEffect(() => {
    outsideComponentDispatch(setAppPageStep(ForgetPasswordPageStep.SUBMIT));
  }, []);

  return (
    <React.Fragment>
      {isMobileOnly ? <MobileView /> : <DesktopView />}
      {appPageStep === CommonPageStep.LOGIN ? <Navigate to="/Login" /> : null}
      {appPageStep === CommonPageStep.FORGETEMAIl ? (
        <Navigate to="/ForgetEmail" />
      ) : null}
    </React.Fragment>
  );
};
